import { toast } from 'sonner';

/** Toast for an on-demand DNS check, shared by the company and admin surfaces. */
export function toastVerifyOutcome(result: {
  claim: { domain: string };
  outcome: 'verified' | 'not-found' | 'error';
}): void {
  if (result.outcome === 'verified') {
    toast.success(`${result.claim.domain} is verified`);
  } else if (result.outcome === 'not-found') {
    toast.info('Record not found yet', {
      description:
        'DNS answered without the challenge record. Publishing can take a while to propagate; try again in a few minutes.',
    });
  } else {
    toast.error('DNS lookup failed', {
      description: 'The resolver did not answer, so nothing was concluded. Try again shortly.',
    });
  }
}
